<template>
    <a-drawer
        :visible="visible"
        title="计划单模板导入"
        :mask-closable="false"
        class="import-plan-modal"
        ok-text="提交"
        width="704px"
        @close="onCancel"
    >
        <!-- <block-title title="下载模板" class="block" :show-line="false">
            <a-button icon="download" @click="downloadTemplate">计划单导入模板</a-button>
        </block-title> -->
        <block-title title="选择文件" class="block" :show-line="false">
            <div class="item-content">
                <div class="content-upload">
                    <a-upload :show-upload-list="false" :before-upload="beforeUpload">
                        <a-button class="uploadBtn" :disabled="uploading" type="primary">
                            <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="" />
                            {{ selectFileBtnTxt }}
                        </a-button>
                    </a-upload>
                </div>
                <p class="tips">单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx/xls</p>
                <div v-if="file" class="batch-file">
                    <div>
                        <a-icon type="file" />
                        {{ file.name }}
                    </div>
                    <img
                        class="filenameRight cursor"
                        src="@/assets/img/icon/icon_lajitong.png"
                        alt=""
                        @click="removeFile"
                    />
                </div>
            </div>
        </block-title>
        <block-title v-if="false" title="排线规则" class="block" :show-line="false">
            <a-radio-group v-model="planMethod" class="item-content" :options="PLAN_METHOD">Radio</a-radio-group>
        </block-title>
        <block-title title="计划时间" class="block" :show-line="false">
            <div>
                <p class="tips desc">
                    <a-icon type="info-circle" />
                    请选择计划时间范围，建议周期为周一 ~ 周日
                </p>
                <a-range-picker v-model="planTime" :allow-clear="false" :disabled-date="disabledDate" />
            </div>
        </block-title>
        <block-title title="订单合并" class="block" :show-line="false">
            <div>
                <p class="tips desc">
                    <a-icon type="info-circle" />
                    计划单剩余待处理订单，是否选择合并
                </p>
                <a-switch v-model="orderMerge" class="item-content" checked-children="开" un-checked-children="关" />
                <p v-if="orderMerge" class="check-list">
                    已选中
                    <span>
                        {{ selectedRowKeys.length }}
                    </span>
                    项
                </p>
            </div>
            <a-table
                v-if="orderMerge"
                :columns="PROCESSEDCOLUMN"
                :data-source="processList"
                class="plan-table table-sigle"
                row-key="planCode"
                :pagination="false"
                :row-selection="{
                    onChange,
                    selectedRowKeys: selectedRowKeys
                }"
            >
                <template slot="planName" slot-scope="text">
                    <a-tooltip>
                        <template slot="title">
                            {{ text }}
                        </template>
                        <div class="ellipsis1">{{ text }}</div>
                    </a-tooltip>
                </template>
                <template slot="action" slot-scope="text, rowData">
                    <a-button type="link" @click="showMore(rowData)">查看</a-button>
                </template>
            </a-table>
        </block-title>
        <div class="drawer-bottom">
            <a-button @click="onCancel">取消</a-button>
            <a-button type="primary" class="submit-btn" :loading="loading" @click="onSubmit">提交</a-button>
        </div>
        <single-plan ref="singlePlan" />
    </a-drawer>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue';
import { getFileNameSuffix } from '@/utils/handleFile.js';
import { getConfig } from '@/pages/orderManage/api';
import moment from 'moment';
import { getAppClientCode } from '@/utils/auth';
import SinglePlan from './singlePlan.vue';
import { planImport, getPendingList } from '../../api';
import { PLAN_METHOD, PROCESSEDCOLUMN } from '../const';
import { fetchTaskList } from '../../../../task/api';

export default {
    name: 'ImportPlan',
    components: {
        BlockTitle,
        SinglePlan
    },
    data() {
        return {
            PROCESSEDCOLUMN,
            processList: [],
            visible: false,
            uploading: false,
            file: null,
            // 文件最大10M
            fileMaxSize: 1024 * 1024 * 10,
            // 文件类型暂时只支持 .xlsx
            fileTypeLimit: ['.xlsx', '.xls'],
            timer: null,
            PLAN_METHOD,
            planMethod: '成本最优',
            planTime: null,
            orderMerge: true,
            selectedRowKeys: [],
            loading: false // 任务提交loading
        };
    },
    computed: {
        selectFileBtnTxt() {
            return !this.file ? '选择文件' : '重新选择';
        }
    },
    methods: {
        disabledDate(current) {
            return current && current < moment('2022-01-01');
        },
        show() {
            this.visible = true;
            this.getPendingList();
        },
        async getPendingList() {
            // let customerCode = null;
            // if (getAppClientCode('appClientCode') === 'otms') {
            //     const data = await getConfig({
            //         appId: '1004',
            //         keys: ['zuwang.OTMS.data.access']
            //     });

            //     const value = (data.configs?.[0]?.value || '').split(',');
            //     customerCode = value && value.length ? JSON.parse(value[0]) : null;
            // }
            const res = await getPendingList({
                customerCode: getAppClientCode('appClientCode') === 'otms' ? null : this.$store.state.user.customerCode,
                endCreateTime: moment()
                    .endOf('day')
                    .format('YYYY-MM-DD HH:mm:ss'),
                startCreateTime: moment()
                    .subtract(13, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss')
            });
            res.map((item) => {
                const listItem = item;
                listItem.confirmTime = moment(item.confirmTime).format('YYYY-MM-DD HH:mm');
                return listItem;
            });
            this.processList = res;
        },
        showMore(record) {
            this.$refs.singlePlan.show(record);
        },
        onChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        async downloadTemplate() {
            const res = await getConfig({ keys: ['WIRING_TEMPLATE_URL'] });
            this.download(res.configs[0].value);
        },
        download(url, fileName = '计划单导入模板') {
            const x = new XMLHttpRequest();
            x.open('GET', url, true);
            x.responseType = 'blob';
            x.onload = () => {
                const csvUrl = window.URL.createObjectURL(x.response);
                const link = document.createElement('a');
                link.href = csvUrl;
                link.download = fileName;
                link.click();
            };
            x.send();
        },
        onCancel() {
            this.uploading = false;
            this.file = null;
            this.visible = false;
            this.selectedRowKeys = [];
            this.orderMerge = true;
            this.planMethod = '成本最优';
        },
        removeFile() {
            this.file = null;
        },
        // 校验文件格式
        validateFile(file) {
            const { fileMaxSize, fileTypeLimit } = this;
            const fileSize = file.size;
            const fileType = getFileNameSuffix(file.name);

            if (!fileTypeLimit.includes(fileType)) {
                this.file = null;
                this.$message.error('文件格式仅支持xlsx');
                return;
            }
            if (fileSize > fileMaxSize) {
                this.file = null;
                this.$message.error('文件最大不超过10M');
            }
        },
        beforeUpload(file) {
            this.file = file;
            this.validateFile(file);
            return false;
        },
        async onSubmit() {
            const { file, planTime } = this;
            if (!file) {
                this.$message.warning('请选择需要上传的文件');
                return;
            }
            if (this.timer) {
                return;
            }
            if (!planTime) {
                this.$message.warning('请选择计划时间');
                return;
            }
            if (planTime[1] - planTime[0] > 2592000000) {
                this.$message.warning('根据计划要求，时间范围不可超过30天');
                return;
            }
            this.timer = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('planMethod', this.planMethod);
            formData.append('startTime', new Date(moment(planTime[0]).startOf('day')).getTime());
            formData.append('endTime', new Date(moment(planTime[1]).startOf('day')).getTime());
            if (this.orderMerge && this.selectedRowKeys.length) {
                formData.append('mergePlanCodes', [...this.selectedRowKeys]);
            }
            this.uploading = true;
            this.loading = true;
            try {
                const res = await planImport(formData);
                this.$message.success('提交成功！');
                this.onCancel();
                this.uploading = false;
                this.loading = false;
                this.timer = false;
                // 需要查询文件验证情况
                // let taskTimer = setInterval(async () => {
                //     const tasksRes = await fetchTaskList({ taskId: res.taskId });
                //     const task = tasksRes?.records[0];
                //     if (!task || task.status === 'FINISHED') {
                //         if (task?.resultMsg.startsWith('成功')) {
                //             this.$message.success('提交成功！');
                //         } else {
                //             this.$message.error('提交失败，请前往右上角任务中心查看失败原因!');
                //         }
                //         this.onCancel();
                //         this.timer = false;
                //         clearInterval(taskTimer);
                //         taskTimer = null;
                //         this.uploading = false;
                //         this.loading = false;
                //         setTimeout(() => {
                //             this.timer = false;
                //         }, 3000);
                //         this.$emit('cancel');
                //     }
                // }, 3000);
            } catch {
                this.uploading = false;
                this.loading = false;
                setTimeout(() => {
                    this.timer = false;
                }, 3000);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.import-plan-modal {
    /deep/ .ant-drawer-header {
        background: #fff;
        border: none;
    }
    /deep/ .ant-drawer-body {
        padding: 16px 32px 68px 0;
        height: calc(100% - 60px);
        overflow-y: auto;
    }
    .tips {
        margin-top: 8px;
        margin-bottom: 18px;
        color: #808792;
        font-size: 13px;
        line-height: 20px;
    }
    .desc {
        margin-top: -8px;
        margin-bottom: 16px;
        color: #808792;
        font-size: 13px;
        line-height: 20px;
    }
    .block {
        margin-bottom: 24px;
        margin-left: 32px;
        // > div {
        //   margin-left: 32px;
        // }
        /deep/ .title-containe {
            margin-left: 8px;
        }
        .check-list {
            margin-top: 20px;
            margin-bottom: 12px;
            color: #323232;
            span {
                color: #06b880;
            }
        }
        .plan-table {
        }
        .batch-file {
            border-radius: 4px;
            color: #404b5c;
            margin-top: 16px;
            // width: 456px;
            // height: 64px;
            // padding: 0 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .batchBtnStyle {
            background: #f2fbf8;
            .icon-xlsx {
                width: 46px;
                height: 46px;
                margin-right: 16px;
            }
            .icon_load {
                width: 24px;
                height: 24px;
            }
        }
        .item-content {
            .uploadBtn {
                width: 160px;
                height: 32px;
                background: #06b880;
                border-radius: 2px;
                .uploadStyle {
                    margin-right: 12px;
                }
            }
        }
        .cursor {
            cursor: pointer;
        }
    }
    .drawer-bottom {
        position: absolute;
        bottom: 0;
        height: 56px;
        background: #fff;
        width: 100%;
        z-index: 99;
        padding: 0 24px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-top: 1px solid #ebedf0;
        .submit-btn {
            margin-left: 12px;
        }
    }
}
</style>
